<template>
    <div class="checkbox-wrapper">
        <v-expansion-panels v-model="expanded" style="background-color: transparent">
            <v-expansion-panel expand>
                <v-expansion-panel-title class="v-subheader theme--light">
                    {{ $t(`filterTitles.${filter}`) }}
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <v-checkbox
                        v-for="(item, index) in partOfValues"
                        :key="`${index}-${item.value}`"
                        v-model="checked"
                        small
                        :hide-details="true"
                        :class="{'pb-3': index + 1 === partOfValues.length}"
                        class="py-0 my-0 full-width"
                        :value="item.value"
                        density="compact"
                        :ripple="!$breakpoint.smAndDown"
                    >
                        <template v-slot:label>
                            <div class="d-flex label-wrapper full-width ms-2 mb-n2">
                                <hotel-tripadvisor-rating-label :tripadvisor-rating="{rating: item.value}" />
                            </div>
                        </template>
                        <template v-slot:append>
                            <div class="ms-auto filter-qty font-weight-bold me-2">
                                {{ `${item.count}` }}
                            </div>
                        </template>
                    </v-checkbox>
                    <v-btn
                        v-if="values.length > showLimit"
                        block
                        size="x-small"
                        variant="text"
                        @click="showAll = !showAll"
                    >
                        {{ showAll ? $t('hide') : $t('show') }} {{ $t('all') }}
                    </v-btn>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-divider />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {CheckboxFilter} from '@/components/search/filters/CheckboxFilter.vue'
    import HotelTripadvisorRatingLabel from '~src/components/snippets/hotelTripadvisorRatingLabel.src'

    @Component({
        components: {
            HotelTripadvisorRatingLabel,
        },
    })
    export class TripadvisorFilter extends CheckboxFilter {}

    export default TripadvisorFilter
</script>

<style lang="scss" scoped>
    .label-wrapper {
        width: 100%;
    }

    .label-text {
        font-size: 13px;
    }

    .checkbox-container {
        max-height: 500px;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #ddd;
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #6699cc;
        border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b3d4fc;
    }

    :deep(.v-input__append-outer) {
        margin-left: auto;
    }

    .filter-qty {
        color: grey;
        font-size: 10px;
    }

    :deep(.v-expansion-panel-content__wrap) {
        padding: 0;
    }
</style>
